import React from "react";
import { Link } from "react-router-dom";

export const AccessDenied = () => {
  return (
    <div
      className="d-flex align-items-center justify-content-center bg-light"
      style={{ minHeight: "100vh" }}
    >
      <div
        className="text-center"
        style={{ maxWidth: "600px", width: "100%" }}
      >
        {/* Logo */}
        <div className="mb-3">
          <Link to={"/"}>
            <img
              src="https://d2lvj32mp5x83n.cloudfront.net/static/logo-YQ/YQLogoPlainBig.png"
              alt="YQ"
            />
          </Link>
        </div>

        {/* Heading */}
        <h4 className="NotFoundSctnheading mb-3 mt-4">
        Oops!
        </h4>

        {/* Message */}
        <p className="NotFoundSctnpara mb-4">
         You don’t have permission to view this. Please sign in with the right account.
          Please return to your dashboard.
        </p>

        {/* Button */}
        <Link
          to="/login"
          className="btn btn-outline-primary w-100 bg-primary text-white"
        >
          Go to Dashboard
        </Link>
      </div>
    </div>
  );
};
